import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import pinia from './store'
import vuetify from './plugins/vuetify'
import cookies from './plugins/vue-cookie'
import { useUserStore, useAppStore, useWwStore, useRootStore } from '@/store'
// Import global styles
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'
import 'nprogress/nprogress.css'
import { configure } from "vue-gtag";
configure({
  tagId: "G-W3YC81ZC30",
  pageTracker: {
    router,
  }
})
// Convert PascalCase/camelCase to kebab-case
function toKebabCase(str) {
  return str
    .replace(/^_/, '')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase()
}

// Create Vue app
const app = createApp(App)

// Use plugins
app.use(pinia)
app.use(router)
app.use(vuetify)
app.use(cookies)
const userStore = useUserStore()
const wwStore = useWwStore()

// Critical data - needed for initial render and filters
// Load these first and show the app immediately after
Promise.all([
  userStore.loadUser(),
  wwStore.loadQuarters(),
  wwStore.loadSectors(),
  wwStore.loadClassifications(),
  wwStore.loadCountries(),
  wwStore.loadSECCodeStates(),
  wwStore.loadStockCountries(),
  wwStore.loadInvestingStyles(),
  userStore.loadEmailAlerts(),
      userStore.loadTrackedBacktests(),
      userStore.loadInsiderAlerts(),
      userStore.loadTradingModels(),
      userStore.loadGroups(),
    userStore.loadWatchlists(),

    // Reference data not needed for filters
    wwStore.loadGlobalExchanges(),
    wwStore.loadGlobalCountries(),
    
]).then(() => {
  wwStore.init = true

  // Deferred data - load after app is visible (improves LCP)
  // Use requestIdleCallback to avoid blocking the main thread
  const loadDeferred = () => {
    // User-specific data
    
    wwStore.loadOwnershipTCodes()
    // Low priority - can load last
    setTimeout(() => {
      
      userStore.loadMostActiveStocks()
      userStore.loadMostActiveFilers()
      userStore.loadTrendingStocks()
      userStore.loadTrendingFilers()
    }, 100)
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadDeferred)
  } else {
    setTimeout(loadDeferred, 0)
  }
})
/*userStore.loadGroups()
userStore.loadEmailAlerts()
userStore.loadTrackedBacktests()
userStore.loadInsiderAlerts()
userStore.loadTradingModels()
userStore.loadMostActiveStocks()
userStore.loadMostActiveFilers()
userStore.loadTrendingStocks()
userStore.loadTrendingFilers()
useUserStore().loadWatchlists()
useWwStore().loadQuarters()
useWwStore().loadSectors()
useWwStore().loadClassifications()
useWwStore().loadCountries()
useWwStore().loadSECCodeStates()
useWwStore().loadGlobalExchanges()
useWwStore().loadGlobalCountries()
 useWwStore().loadStockCountries()
 useWwStore().loadOwnershipTCodes()*/

// Auto-import components
const requireComponent = import.meta.glob('./components/**/*.vue', { eager: true })
Object.entries(requireComponent).forEach(([path, component]) => {
  // Get component name from path (e.g., "Toolbar.vue" -> "Toolbar")
  const componentName = path
    .split('/')
    .pop()
    .replace(/\.vue$/, '')

  // Get folder path (e.g., "./components/core/Toolbar.vue" -> ["core"])
  const folders = path.split('/').slice(2, -1)

  // Build full component name in kebab-case (e.g., "core-toolbar")
  const fullName = [...folders, componentName].map(toKebabCase).join('-')

  app.component(fullName, component.default || component)
})

// Mount app
app.mount('#app')
